import { MARK_AVO_FRESH, MARK_AVO_STALE } from '../actionTypes/avoActionTypes';

export const markAvoStale = () => ({
    type: MARK_AVO_STALE
});

export const markAvoFresh = () => ({
    type: MARK_AVO_FRESH
});
